import * as Yup from 'yup';
import * as moment from 'moment';
import { BIDFORMAT, FORMAT } from './dateOfBirthValidation';

export function getInitialValues(response, addressState) {
    let plusTwo = new Date().setDate(new Date().getDate() + 3)
    let bidDate = moment(plusTwo).format(BIDFORMAT)

    let currentTimeBegin = new Date()
    currentTimeBegin.setHours(8)
    currentTimeBegin.setMinutes(0)

    let beginHours = currentTimeBegin.getHours();
    let beginMinutes = currentTimeBegin.getMinutes()
    let beginCurrentTime = beginHours + ':' + beginMinutes

    let currentTimeEnd = new Date()
    currentTimeEnd.setHours(17)
    currentTimeEnd.setMinutes(0)

    let endHours = currentTimeEnd.getHours();
    let endMinutes = currentTimeEnd.getMinutes()
    let endCurrentTime = endHours + ':' + endMinutes

    let offerLessQuantity = response.quantity
    if (offerLessQuantity === undefined || offerLessQuantity === null) {
        offerLessQuantity = ''
    }

    let deliveryBeginTime = beginHours + ':' + beginMinutes
    let deliveryEndTime = endHours + ':' + endMinutes

  
    // const currentdate = new Date();
    let dateSet = new Date();
    dateSet = moment(new Date(new Date().setHours(new Date().getHours() + 24)))
    // if(isAlternateQuantity === "alternateQtyYes"){
    //     dateSet = moment(new Date(new Date().setHours(new Date().getHours() + 24)))
    // }else{
    //     if(response?.requestedDate){
    //         dateSet = moment(new Date(response?.requestedDate * 1000).toLocaleString()).format(FORMAT)
    //     }
    // }
    
    //add condition 
    bidDate =  moment(dateSet).format(BIDFORMAT)

    const pickUpDeliverableValue = () => {
        let state = '';
        if(response?.postType === "NEED") {
            if(response?.shippingMode !== 'DELIVERY'){
                state = 'PICK_UP';
            }else{
                state = 'DELIVERABLE';
            }
        }else{
            if(response?.shippingMode === 'DELIVERY'){
                state = 'DELIVERABLE';
            }else{
                state = 'PICK_UP';
            }
        }
        return state;
    }
    
    return {
        name: addressState?"" :response?.shippingAddress?.locationName,
        line1: addressState?"":response?.shippingAddress?.address1,
        line2: addressState?"":response?.shippingAddress?.address2,
        city: addressState?"":response?.shippingAddress?.city,
        state: addressState?"":response?.shippingAddress?.state,
        zip: addressState?"":response?.shippingAddress?.zipCode,

        // timeZone: addresstimeZone,
        offerPrice: '',
        quantity: response?.quantity,
        confirmBid: false,
        // pickUpDeliverable: 'PICK_UP',
        pickUpDeliverable: pickUpDeliverableValue(), 
        pickupWindowBegin: response?.appointmentStartTime? response?.appointmentStartTime : deliveryBeginTime,
        pickupWindowEnd: response?.appointmentEndTime? response?.appointmentEndTime : deliveryEndTime,
        deliveryWindowBegin: response?.appointmentStartTime? response?.appointmentStartTime : deliveryBeginTime,
        deliveryWindowEnd: response?.appointmentEndTime? response?.appointmentEndTime : deliveryEndTime,
        sellerPostInventoryId: '',
        comment: '',
        deliveryDateCheckout: bidDate,
    }
}
const setTimmer=(setbidTimeArr)=>{
    let setHours = setbidTimeArr[0]
    let setMinutes = setbidTimeArr[1]
    if (setbidTimeArr[0].length === 1) {
        setHours = 0 + setbidTimeArr[0]
    }
    if (setbidTimeArr[1].length === 1) {
        setMinutes = 0 + setbidTimeArr[1]
    }
    return  setHours + ':' + setMinutes   
}
const VALIDATION_SCHEMA = (pageLanguageContents,addressState) => {
    let schemaAttributes
    if(addressState){
        schemaAttributes = {
            name:Yup.string().trim().required("Company name is required."),
            line1:Yup.string().trim().required("Address Line 1 is required."),
            city:Yup.string().trim().required("City is required."),
            state:Yup.string().trim().required("State is required."),
            zip:Yup.string().trim().required("Zip is required."),
            offerPrice: Yup.string().trim().required(pageLanguageContents?.ErrorValidations[0]?.OfferReq),
            quantity: Yup.string().trim().required(pageLanguageContents?.ErrorValidations[1]?.Quantityreq),
            confirmBid: Yup.boolean().oneOf([true], pageLanguageContents?.ErrorValidations[2]?.SelectCheckbox),
            comment: Yup.string().trim().required(pageLanguageContents?.ErrorValidations[3]?.CommentReq),
        }
    }else{
        schemaAttributes = {
            offerPrice: Yup.string().trim().required(pageLanguageContents?.ErrorValidations[0]?.OfferReq),
            quantity: Yup.string().trim().required(pageLanguageContents?.ErrorValidations[1]?.Quantityreq),
            confirmBid: Yup.boolean().oneOf([true], pageLanguageContents?.ErrorValidations[2]?.SelectCheckbox),
            comment: Yup.string().trim().required(pageLanguageContents?.ErrorValidations[3]?.CommentReq),
        }
    }
        
    return Yup.object().shape(schemaAttributes);
}

export { VALIDATION_SCHEMA };